import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import type { PayloadAction } from '@reduxjs/toolkit';
import { resetLoading, setLoading, setTitleLoading } from 'redux/ui/loadings-slice';
import { MotivoType } from 'models/motivo';
import { getMotivos } from 'services/http/motivo-service';
import { showMessage } from 'utils/messages';
import { AxiosResponse } from 'axios';

type MotivoState = {
    motivos: MotivoType[];
    selecionado?: MotivoType;
}

const initialState : MotivoState = {
    motivos: []
}

const handleSetSelecionado = (state:MotivoState, action: PayloadAction<MotivoType> ) =>{
  state.selecionado = action.payload
}


export const fetchGetMotivos = createAsyncThunk(
    `motivos/getMotivos`,
    async  (props, { dispatch })  =>{
        dispatch(setLoading(true));
        dispatch(setTitleLoading("Carregando motivos do bloqueio..."));
        const response = await getMotivos()
        .catch( error =>{
            const { mensagem } = error.response.data;
            showMessage("warning", "Atenção!", mensagem);
        }) as AxiosResponse;
        dispatch(setLoading(false));
        dispatch(resetLoading());
        return response;
    });

export const motivoSlices = createSlice({
  name: 'motivos',
  initialState: { ...initialState },
  reducers: {
    setMotivoSelecionado: handleSetSelecionado,
    cleanState: state => {
      state.motivos = [];
      state.selecionado = undefined;
    }
  },
  extraReducers: ( builder )=>{
    builder.addCase(fetchGetMotivos.fulfilled, (state, action) =>{
      state.motivos = action.payload.data as MotivoType[];
    });
    }
  });

export const {
    setMotivoSelecionado,
    cleanState,
} = motivoSlices.actions;
export default motivoSlices.reducer;
